module.exports = __webpack_public_path__ + "media/ppc/the-new-york-times-345b17ba.png";